import React from 'react';
import classNames from 'classnames';
import { getListingBannerImage } from '../../../../util/dataExtractor';
import css from './SectionBrandHero.module.css';

function BrandWhiteLabelBanner({ listing }) {
  const bannerImageState = getListingBannerImage(listing);
  if (!bannerImageState) {
    return <></>;
  }
  return (
    <div className={classNames(css.howItWorks, css.brandTopBanner)}>
      <div className={css.startContent}>
        <div className={css.sectionHead}>
          <div className={css.bannerWrapper}>
            <div className={css.bannerImage}>
              <img src={bannerImageState} alt="Banner" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BrandWhiteLabelBanner;
